module.exports = __webpack_public_path__ + "static/img/qidai.aa5c5afa.png";